/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Share_SelectedInputs */

const en_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No share selected`)
};

const fr_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun partage sélectionné`)
};

const de_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Aktie ausgewählt`)
};

const it_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna condivisione selezionata`)
};

const ru_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акции не выбраны`)
};

const es_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ninguna acción`)
};

const zh_cn2_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何股份`)
};

const ja_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有が選択されていません`)
};

const hi_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई शेयर चयनित नहीं`)
};

const pt_pt2_team_share_no_share_selected = /** @type {(inputs: Team_Share_No_Share_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma ação selecionada`)
};

/**
* | output |
* | --- |
* | "No share selected" |
*
* @param {Team_Share_No_Share_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_share_selected = /** @type {((inputs?: Team_Share_No_Share_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Share_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_no_share_selected(inputs)
	if (locale === "de") return de_team_share_no_share_selected(inputs)
	if (locale === "it") return it_team_share_no_share_selected(inputs)
	if (locale === "ru") return ru_team_share_no_share_selected(inputs)
	if (locale === "es") return es_team_share_no_share_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_no_share_selected(inputs)
	if (locale === "ja") return ja_team_share_no_share_selected(inputs)
	if (locale === "hi") return hi_team_share_no_share_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_no_share_selected(inputs)
	return en_team_share_no_share_selected(inputs)
});